import { IPPVPurchasePayload, IPPVPurchaseResponse } from '../../../entity';
import { IUserRegistrationRepository } from '../../repositories/interfaces/iUserRegistrationRepository';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';

export interface IPPVPurchaseUseCase {
    execute(
        payload: IPPVPurchasePayload,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IPPVPurchaseResponse>;
}

export class PPVPurchaseUseCase implements IPPVPurchaseUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRegistrationRepo(): IUserRegistrationRepository {
        return container.resolve<IUserRegistrationRepository>(DI.REPOSITORIES.IUserRegistrationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IPPVPurchasePayload,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: { [key: string]: string }
    ): Promise<IPPVPurchaseResponse> {
        const response = await this.userRegistrationRepo.ppvPurchase(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        return response;
    }
}
